import { Permission } from 'entities/user';
import { AppState } from '../AppTypes';

export const _hasPermissionsAtLeastOne = (state: AppState) => {
  return (permissions: Permission[]) => {
    if (!permissions || permissions.length === 0) {
      //If required permissions is empty then we aren't asking for any
      //permissions to be present so return true.
      return true;
    }
    const userPerms = state?.userInfo?.permissions;
    if (state?.userInfo?.accessLevel && userPerms) {
      return permissions.some(p => userPerms.includes(p));
    }
    return false;
  };
};
